import { getAwsAssets } from "@src/utils";
import { Image } from "@src/components/Image";
import React from "react";
import isVideoExhausted from "../../helpers/isVideoExhausted";
import styles from "../../styles/ContentList.module.scss";

const VideoContentCases = ({ content }) => {
  return (
    <React.Fragment>
      <div className={styles.contentList__item__content__limits}>
        {content?.leftViewsEmblem?.value &&
          content?.leftViewsEmblem?.value > 0 &&
          !isVideoExhausted(content) && (
            <div style={{ color: content?.leftViewsEmblem?.textColor }}>
              {content?.leftViewsEmblem?.icon[
                content?.leftViewsEmblem?.textColor
              ] && (
                <img
                  src={
                    content?.leftViewsEmblem?.icon[
                      content?.leftViewsEmblem?.textColor
                    ]
                  }
                  alt="eyeIcon"
                  width="14px"
                  height="14px"
                />
              )}
              {content?.leftViewsEmblem?.text}:{" "}
              <span style={{ color: content?.leftViewsEmblem?.valueColor }}>
                {content?.leftViewsEmblem?.value}
              </span>
            </div>
          )}
        {content?.leftDurationEmblem?.value &&
          content?.leftDurationEmblem?.value !== -1 &&
          !isVideoExhausted(content) && (
            <div style={{ color: content?.leftDurationEmblem?.textColor }}>
              {content?.leftDurationEmblem?.icon[
                content?.leftDurationEmblem?.textColor
              ] && (
                <img
                  src={
                    content?.leftDurationEmblem?.icon[
                      content?.leftDurationEmblem?.textColor
                    ]
                  }
                  alt="clockIcon"
                  width="14px"
                  height="14px"
                />
              )}
              {content?.leftDurationEmblem?.text}:{" "}
              <span style={{ color: content?.leftDurationEmblem?.valueColor }}>
                {content?.leftDurationEmblem?.value}
              </span>
            </div>
          )}
        {isVideoExhausted(content) ? (
          <div
            className={styles.contentList__item__content__limits__exhausted}
            style={{ color: content?.thresholdColor }}
          >
            {content?.thresholdText}
          </div>
        ) : null}
      </div>
    </React.Fragment>
  );
};

export default VideoContentCases;
